/* eslint-disable @typescript-eslint/no-explicit-any */
import { Modal } from "flowbite-react";
import GenericTable from "../../../../common/components/ui/table/GenericTable";
import { numberToCurrency } from "../../../../common/helpers/currency.helpers";
import { formatDate } from "../../../../common/helpers/date.helpers";
import { PAYMENT_STATUS } from "../../../../types/payment.type";
import React from "react";

interface TablePaymentsPreviewProps {
  modalPayment: boolean;
  setModalPayment: (show: boolean) => void;
  payments: Record<string, unknown>[];
  withInactiveStyle: (content: React.ReactNode, data: Record<string, any>) => React.ReactNode;
  getStatusLabels: (status: string) => string;
}

export function TablePaymentsPreview({
  modalPayment,
  setModalPayment,
  payments,
  withInactiveStyle,
  getStatusLabels,
}: TablePaymentsPreviewProps) {

  const tableHeaders = {
    "description": "Descrição",
    "value": "Valor",
    "dueDate": "Vencimento",
    "status": "Status",
  };
  return (
    <>
      {modalPayment && (
        <Modal
          className="dark:text-black"
          size="8xl"
          onClose={() => setModalPayment(false)}
          show={modalPayment}
        >
          <Modal.Header>
            <h2 className="label">Pagamentos</h2>
          </Modal.Header>
          <Modal.Body>
            <GenericTable
              headers={tableHeaders}
              data={payments}
              renders={{
                description: (description, data) =>
                  withInactiveStyle(description, data),

                value: (value, data) =>
                  withInactiveStyle(numberToCurrency(value), data),

                dueDate: (date, data) =>
                  withInactiveStyle(formatDate(date), data),

                paymentDate: (date, data) =>
                  withInactiveStyle(date ? formatDate(date) : "-", data),

                status: (status) => {
                  const label = getStatusLabels(status);
                  let className = "";

                  switch (status) {
                    case PAYMENT_STATUS.RECEIVED:
                      className = "text-greenDark font-semibold";
                      break;
                    case PAYMENT_STATUS.PENDING:
                      className = "text-bluePrimary font-semibold";
                      break;
                    case PAYMENT_STATUS.OVERDUE:
                      className = "text-redPrimary font-semibold";
                      break;
                    case PAYMENT_STATUS.Inativo:
                      className = "text-gray";
                      break;
                    default:
                      className = "";
                  }

                  return <span className={className}>{label}</span>;
                },

                invoiceUrl: (link, data) =>
                  withInactiveStyle(
                    <a href={link as string} target="_blank" rel="noopener noreferrer">link</a>,
                    data
                  ),
              } as any}
            />
          </Modal.Body>

        </Modal>
      )}
    </>
  );
}